import { useSyncExternalStore } from "react"

import {
  getAppearanceState,
  setAppearanceMode,
  subscribeAppearance
} from "./appearance-store"

export const useAppearance = () => {
  const state = useSyncExternalStore(subscribeAppearance, getAppearanceState)
  return { ...state, setMode: setAppearanceMode }
}
